<img loading="lazy" [src]="source" width="100%" (error)="handlerError()">
